<!-- Bonus tax warning -->
<ui-banner variant="warning" *ngIf="isShowingBonusTaxWarning">
    {{ 'forms.edit-bonus-pay-items.bonusAmountsEnteredIsGreaterThanRegularPayAmountBeforeRunningPay' | translate }}
</ui-banner>

<form *ngIf="paystub" class="app-grid" #form="ngForm" autocomplete="off">
    <mat-form-field *ngFor="let payItem of paystub.bonusPayItems" class="columns-12">
        <mat-label>{{ getDisplayName(payItem) }}</mat-label>
        <input
            matInput
            [name]="'amount-' + payItem.name"
            [(ngModel)]="payItem.amount"
            #amount="ngModel"
            type="number"
            [min]="0"
            (ngModelChange)="checkForOvertax()"
        />
        <mat-error *ngIf="amount.invalid">{{ amount.errors | formErrors }}</mat-error>
    </mat-form-field>
</form>
